import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { WorkingSessionChartPoint } from 'src/common/types';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom' as const,
      align: 'start' as const,
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
      },
    },
  },
  scales: {
    x: {
      ticks: {
        maxRotation: 45,
        minRotation: 45,
      }
    },
    y: {
      beginAtZero: true,
    },
  },
};

interface Props {
    chartData: WorkingSessionChartPoint[];
    title: string;
    borderColor: string;
    backgroundColor: string;
    pointBackgroundColor: string;
    pointBorderColor: string;
}

export default function Chart({ chartData, title, borderColor, backgroundColor, pointBackgroundColor, pointBorderColor }: Props) {
  const labels = chartData.map((data) => {
      return new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric', hour12: false }).format(new Date(data.time));
  });
  const data = {
    labels,
    datasets: [{
      label: title,
      data: chartData.map(item => item.value),
      fill: true,
      borderColor,
      backgroundColor,
      tension: 0,
      pointRadius: 0,
      pointBackgroundColor,
      pointBorderColor,
    }]
  };

  return (
    <div className="w-full" style={{ height: '250px' }}>
      {
        chartData.length ? 
          <Line options={options} data={data} /> :
          <div className="w-full d-flex justify-content-center align-items-center" style={{ height: '250px' }}>
            No Data
          </div>
      }
    </div>
  );
}
